module.exports = __webpack_public_path__ + "img/window_view.1a2ebc78.png";